export default __webpack_public_path__ + "static/media/alerrt_ai.d5bc76e6.svg";